export default __webpack_public_path__ + "static/media/ICouldntBelieveIt60s.5892fecc.mp3";